import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { tap } from 'rxjs';
import config from '../../admin/config';
import { AuthService } from '../../api/auth.service';
import { HookDirective } from '../../common/core/hook';
import { useState, useTriggerLoad } from '../../common/core/hooks';
import { emailIsValid } from '../../common/input/email';
import { StringParam } from '../../common/state/route';
import { RouteService, useQueryParam } from '../../common/state/route.service';

@Component({
  host: { class: 'rv-grid xlarge outer' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-login-sso',
  templateUrl: './login-sso.component.html',
  styleUrls: ['./login-sso.component.scss'],
})
export class LoginSSOComponent extends HookDirective {
  constructor(
    readonly authService: AuthService,
    readonly routeService: RouteService,
    _cdr: ChangeDetectorRef,
  ) {
    super(_cdr);
  }

  get _() {
    const [envIsZelis] = useState<boolean>(!!config.envIsZelis);

    const [emailQueryParam] = useQueryParam(
      this.routeService,
      new StringParam('email'),
    );
    const [email, setEmail] = useState(emailQueryParam ?? '');
    const [emailHasIssue, setEmailHasIssue] = useState(false);
    const [clientSideError, setClientSideError] = useState('');

    const [showSuccess, setShowSuccess] = useState(false);

    function validateAndSubmit() {
      clearAllErrors();
      if (email.length === 0) {
        setEmailHasIssue(true);
        setClientSideError('Please enter an email address');
      } else if (!emailIsValid(email)) {
        setEmailHasIssue(true);
        setClientSideError('This email address does not appear to be valid');
      } else {
        doSubmit();
      }
    }
    function clearAllErrors() {
      setEmailHasIssue(false);
      setClientSideError('');
      submitLoad.error = null;
    }

    const [submitLoad, doSubmit] = useTriggerLoad(() => {
      return this.authService
        .sendSSOEmail(email)
        .pipe(tap(() => setShowSuccess(true)));
    });

    return {
      envIsZelis,
      email,
      setEmail,
      emailHasIssue,
      clientSideError,
      validateAndSubmit,
      clearAllErrors,
      submitLoad,
      showSuccess,
    };
  }

  openIntercom() {
    Intercom('show');
  }
}
